<div class="row pb-3">
    <div class="col-xl-1 hidden-lg"></div>
    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">

            <div class="row">
                <div class="col-12">

                    <div class="card">
                        <div class="card-body">

                            <form>
                                <div class="form-row">
                                    <!-- <div class="col-xl-4 col-lg-4 col-md-12 col-sm-6 col-xs-12 mb-3">
                                        <label for="src">{{ 'pages.generic.source' | translate }}</label>
                                        <select class="form-control" name="src" aria-describedby="src" [(ngModel)]="source">
                                            <option></option>
                                            <option value="Support">Support</option>
                                        </select>
                                    </div> -->
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <label for="assName">{{ 'pages.generic.name' | translate }}</label>
                                        <input type="text" class="form-control" name="assName" aria-describedby="assName" placeholder="" [(ngModel)]="assetName">
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <label for="assSerial">{{ 'pages.assets.dashboard.fieldTitles.serialNumber' | translate }}</label>
                                        <input type="text" class="form-control" name="assSerial" aria-describedby="assSerial" placeholder="" [(ngModel)]="assetSerialNumber">
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <label for="assVendor">{{ 'pages.assets.dashboard.fieldTitles.vendor' | translate }}</label>
                                        <select class="form-control" name="assVendor" aria-describedby="assVendor" [(ngModel)]="assetVendor">
                                            <option></option>
                                            <option value="{{tt}}" *ngFor="let tt of vendors">{{tt}}</option>
                                        </select>
                                    </div>
                                </div>
                                
                                <button class="btn btn-primary" (click)="search();">{{ 'pages.generic.filter' | translate }}</button>
                                <button class="btn btn-primary" (click)="reset();">{{ 'pages.generic.reset' | translate }}</button>
                            </form>

                        </div>
                    </div>
                    
                </div>
            </div>

    </div>
    <div class="col-xl-1 hidden-lg"></div>
</div>

<div class="row rowfiller">
    <div class="col-xl-1 hidden-lg"></div>
    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">

            <div class="row pt-1">
                <div class="col-12 justify-content-right">
                    <fa-icon [icon]="['fas', 'th-list']" size="2x" class="p-1 click" (click)="changeViewType('list')"></fa-icon>
                    <fa-icon [icon]="['fas', 'th-large']" size="2x" class="p-1 click" (click)="changeViewType('grid')"></fa-icon>
                </div>
            </div>

<!--             <div class="row pt-1">
                <div class="col-12 justify-content-right">
                    <button class="btn btn-primary" (click)="toggleInactive();" *ngIf="includeInactive">{{ 'pages.generic.toggleActive' | translate }}</button>
                    <button class="btn btn-primary" (click)="toggleInactive();" *ngIf="!includeInactive">{{ 'pages.generic.toggleInactive' | translate }}</button>
                </div>
            </div> -->


            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active' : page === 'assets' }" (click)="page = 'assets'; loadAssets();">{{ 'pages.assets.dashboard.assets' | translate }}</a>
                </li> 
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active' : page === 'flagged' }" (click)="loadFlagged();" >{{ 'pages.generic.flagged' | translate }} <span class="badge badge-primary ml-2" style="padding:0.1rem 0.5rem;" *ngIf="flagRefs">{{flagRefs.length}}</span> </a>
                </li>
            </ul>

            <br/><br/>

            <div class="card-body p-t-1 p-3" *ngIf="viewType === 'list' && (page === 'assets' || page === 'flagged')">
                <app-asset-list [assets]="subsetAssets" [flagRefs]="flagRefs" [flaggingRef]="flaggingRef" [loaded]="assetsLoaded" (flagEmitter)="flag($event);" (sortEmitter)="sortAssets($event);"></app-asset-list>
            </div>

            <div class="card-body p-t-1 p-3" *ngIf="viewType === 'grid' && (page === 'assets' || page === 'flagged')">
                <app-asset-grid [assets]="subsetAssets" [flagRefs]="flagRefs" [flaggingRef]="flaggingRef" [loaded]="assetsLoaded" (flagEmitter)="flag($event);"></app-asset-grid>
            </div>

            <div class="card-body justify-content-center p-t-1 p-3" *ngIf="(page === 'assets' || page === 'flagged') && assetsLoaded">
                <ngb-pagination [collectionSize]="assets.length" pageSize="12" page="currentPage" [(page)]="currentPage" [maxSize]="10" aria-label="Pagination" (pageChange)="onPageChange($event)">
                    <ng-template ngbPaginationPrevious></ng-template>
                    <ng-template ngbPaginationNext></ng-template>
                </ngb-pagination>
            </div>

    </div>
    <div class="col-xl-1 hidden-lg"></div>
</div>